/*
表单新建、编辑公共配置信息hooks

*/

import { ref } from 'vue';
import { setService } from '@/api/';
import fieldDefaultVal from '@/hooks/default-value'; //默认值相关的hooks

const { getDefValFields } = fieldDefaultVal();

const useFormConfig = (entity, id, type, isAssociated) => {
  const showApproveBtn = ref(false); // 是否命中审批
  const statusOrigin = ref(null); // 数据生命状态
  const objectName = ref(''); // 对象名称
  const defaultFields = ref([]); // 默认值参与字段

  // 是否命中审批
  const isHitApproval = async () => {
    try {
      // 关联对象表格不走审批逻辑
      if (!isAssociated) {
        const json = await setService.isHitApproval({
          entity: entity,
          businessId: id
        });
        if (json && !json.error) {
          showApproveBtn.value = json.result?.openApprove || false;
          statusOrigin.value = type == 30 ? null : json.result?.statusOrigin;
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 获取对象名称
  const getObjectName = async () => {
    try {
      const res = await setService.getSysObjEnumList({ entityType: entity });
      if (!res.error) {
        objectName.value = res.result?.entityName;
      }
    } catch (e) {
      console.log(e);
    }
  };

  //获取默认值参与条件的字段
  const getDefValFieldList = async () => {
    try {
      const result = await getDefValFields({ entity: entity });
      if (!result.error) {
        defaultFields.value = result?.result || [];
      }
    } catch (e) {
      console.log(e);
    }
  };

  const initFormConfig = () => {
    // 初始化时并行执行所有配置获取
    Promise.all([isHitApproval(), getObjectName(), getDefValFieldList()]);
  };
  return {
    initFormConfig,
    showApproveBtn,
    statusOrigin,
    objectName,
    defaultFields
  };
};

export default useFormConfig;
